'use client'

import IconLoading from '@icon/loading.svg'
import { useEffect, useRef, useState } from 'react'

export default function ScrollLoad({
  loading = false,
  initIndex = 1,
  total = 0,
  size = 20,
  onLoad,
  className = '',
}: {
  loading?: boolean
  initIndex?: number
  total?: number
  size?: number
  onLoad?: (pageIndex: number) => Promise<void>
  className?: string
}) {
  const [pageIndex, setPageIndex] = useState(initIndex)
  const selfRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleDomIntersection(entries: IntersectionObserverEntry[]) {
      const target = entries[0]
      if (target.isIntersecting && !loading && pageIndex * size < total) {
        const nextPage = pageIndex + 1
        onLoad?.(nextPage).then(() => {
          setPageIndex(nextPage)
        })
      }
    }
    const observer = new IntersectionObserver(handleDomIntersection)

    if (selfRef.current) {
      observer.observe(selfRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [loading, pageIndex, onLoad, total, size])

  return (
    <div ref={selfRef} className={className}>
      {loading && (
        <p className='text-center text-secondary-light'>
          <IconLoading className='w-5 h-5 animate-spin mr-2' />
          Loading...
        </p>
      )}
    </div>
  )
}
